module.exports = __webpack_public_path__ + "img/option_3.bb7fa02f.png";